export default __webpack_public_path__ + "5b5e1752300db15ea79f4f61cef7fba1.svg";